import {
  INGESTION_RUN_KINDS,
  INGESTION_TRIGGERS,
  BEER_SOURCE_PROVENANCE_TYPES,
} from '../callableBeerConstants';

export const INGESTION_RUN_FILTER_ALL = '';

export function formatIngestionRunEnumLabel(value) {
  if (typeof value !== 'string' || !value.trim()) {
    return 'Unknown';
  }
  return value
    .trim()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatIngestionRunTimestamp(value) {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return '—';
    }
    return value.toLocaleString();
  }
  if (value && typeof value.toLocaleString === 'function') {
    return value.toLocaleString();
  }
  return '—';
}

export function formatIngestionRunCompletedAt(completedAt) {
  return formatIngestionRunTimestamp(completedAt);
}

export function isExtractionRun(run) {
  return run?.runKind === 'extraction';
}

export function filterBeerIngestionRuns(
  runs,
  {
    statusFilter = INGESTION_RUN_FILTER_ALL,
    triggerFilter = INGESTION_RUN_FILTER_ALL,
    sourceTypeFilter = INGESTION_RUN_FILTER_ALL,
    runKindFilter = INGESTION_RUN_FILTER_ALL,
  } = {},
) {
  return (runs || []).filter((run) => {
    const matchesStatus = !statusFilter || run.status === statusFilter;
    const matchesTrigger = !triggerFilter || run.trigger === triggerFilter;
    const matchesSourceType = !sourceTypeFilter || run.sourceType === sourceTypeFilter;
    const matchesRunKind = !runKindFilter || run.runKind === runKindFilter;
    return matchesStatus && matchesTrigger && matchesSourceType && matchesRunKind;
  });
}

function collectTrimmedStringValues(runs, fieldName, initialValues) {
  const uniqueValues = new Set(initialValues);
  for (const run of runs || []) {
    const fieldValue = run?.[fieldName];
    if (typeof fieldValue === 'string' && fieldValue.trim()) {
      uniqueValues.add(fieldValue.trim());
    }
  }
  return [...uniqueValues];
}

export function collectIngestionRunSourceTypes(runs) {
  return collectTrimmedStringValues(runs, 'sourceType', BEER_SOURCE_PROVENANCE_TYPES);
}

export function collectIngestionRunTriggers(runs) {
  return collectTrimmedStringValues(runs, 'trigger', INGESTION_TRIGGERS);
}

export function collectIngestionRunKinds(runs) {
  return collectTrimmedStringValues(runs, 'runKind', INGESTION_RUN_KINDS);
}

export function beerListKeys(names) {
  const seenCounts = new Map();
  return (names || [])
    .filter((beerName) => typeof beerName === 'string' && beerName.trim())
    .map((beerName) => {
      const trimmedName = beerName.trim();
      const nextCount = (seenCounts.get(trimmedName) || 0) + 1;
      seenCounts.set(trimmedName, nextCount);
      return {
        key: `${trimmedName}#${nextCount}`,
        beerName: trimmedName,
      };
    });
}

export function canRetryIngestionRun(run) {
  if (!isExtractionRun(run) || !run.hasSnapshot) {
    return false;
  }
  const terminal = run.status === 'success'
    || run.status === 'partial'
    || run.status === 'failure';
  if (!terminal) {
    return false;
  }
  return run.status === 'failure' || run.hasValidatedSnapshot !== true;
}
